import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Calculator } from "@/components/Calculator";
import { CalculatorAdvanced } from "@/components/CalculatorAdvanced";
import { InfoSection } from "@/components/InfoSection";
import { Footer } from "@/components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-fuel-pattern flex flex-col" data-testid="home-page">
      <Header />
      <main className="flex-1">
        <Hero />
        <Calculator />
        <InfoSection />
      </main>
      <Footer />
    </div>
  );
};

const AdvancedPage = () => {
  return (
    <div
      className="min-h-screen bg-fuel-pattern flex flex-col"
      data-testid="advanced-page"
    >
      <Header />
      <main className="flex-1">
        <Hero />
        <CalculatorAdvanced />
        <InfoSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/advanced" element={<AdvancedPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
